export default "__VITE_ASSET__Jr3WdVF6__"